import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { IsAdmin } from './roles';

const useProtectRoute = () => {
  const authUser = useSelector((state: RootState) => state.auth.user);
  const router = useRouter();
  useEffect(() => {
    if (!authUser) router.push('/login');
    if (!authUser?.isActive) router.push('/membership/payment');
  }, [authUser, router]);

  return { userLoggedIn: authUser !== null, userIsAdmin: IsAdmin(authUser) };
};

export default useProtectRoute;
